(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("clipboard", [], factory);
	else if(typeof exports === 'object')
		exports["clipboard"] = factory();
	else
		root["clipboard"] = factory();
})(this, function() {
return 